module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Thin.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Thin.woff2
// module id = 53
// module chunks = 8